import { createVNode, defineComponent, h, render } from 'vue'
import './toast.scss'

const TOAST_DURATION = 3000

const ToastComponent = defineComponent({
  name: 'GlobalToast',
  props: {
    message: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    return () =>
      h('div', { class: 'app-toast-wrapper' }, [h('div', { class: 'app-toast-content' }, props.message)])
  },
})

let container = null
let timer = null

function ensureContainer() {
  if (!container) {
    container = document.createElement('div')
    document.body.appendChild(container)
  }
}

function destroyToast() {
  if (!container) {
    return
  }
  render(null, container)
}

function toast(message) {
  if (!message) {
    return
  }

  ensureContainer()
  if (timer) {
    clearTimeout(timer)
  }

  const vnode = createVNode(ToastComponent, {
    message: String(message),
  })
  render(vnode, container)

  timer = setTimeout(() => {
    destroyToast()
    timer = null
  }, TOAST_DURATION)
}

toast.install = (app) => {
  app.config.globalProperties.$toast = toast
}

export default toast
